<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="d-flex pt-3">
			<el-button type="primary" icon="el-icon-plus" size="mini" @click="openModel('notice')">添加</el-button>
			<el-button type="success" icon="el-icon-s-promotion" size="mini">发送消息</el-button>
		</div>
		<!-- 头部标签页 -->
		<el-tabs v-model="tabIndex" @tab-click="getList" class="mt-2"><el-tab-pane :label="tab.name" :key="tabI" v-for="(tab, tabI) in tabbars"></el-tab-pane></el-tabs>

		<!-- 商品列表 -->
		<el-table :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" size="mini" key="table1" :max-height="maxHeight">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column align="center" prop="id" width="60" label="编号" fixed="left"></el-table-column>
			<el-table-column prop="title" label="标题"></el-table-column>
			<el-table-column align="center" label="审核状态">
				<template slot-scope="scope">
					<div class="d-flex" style="justify-content: center;align-items: center;" v-if="scope.row.state == 0">
						<el-button type="primary" size="mini" plain @click="upstate(scope.row.id, 1)">已审核</el-button>
						<el-button type="danger" size="mini" plain @click="upstate(scope.row.id, 2)">不通过</el-button>
					</div>
					<el-button type="success" size="mini" plain v-else-if="scope.row.state == 1">已审核</el-button>
					<el-button type="danger" size="mini" plain v-else>不通过</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" label="发布人">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{ scope.row.fbr.name }}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="create_time" width="140" label="发布时间"></el-table-column>
			<el-table-column align="center" label="操作" fixed="right" width="240">
				<template slot-scope="scope">
					<div v-if="tab != 'delete'">
						<el-button type="primary" size="mini" @click="openModels(scope.row)">查看</el-button>
						<el-button type="primary" size="mini" @click="openModel('notice', scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</div>
					<div v-else>暂无操作</div>
				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>

		<el-dialog title="编辑信息" :visible.sync="dialogVisible" width="80%" :before-close="handleClose" style="margin-top: -110px;">
			<el-form v-if="preUrl === 'notice'" ref="form" :model="form.notice" label-width="100px">
				<el-form-item label="标题" prop="title"><el-input v-model="form.notice.title" placeholder="标题" size="mini" style="width: 90%;"></el-input></el-form-item>

				<el-form-item label="公告内容">
					<tinymce
						ref="editor"
						v-model="form.notice.content"
						@onClick="onClick"
						toolbar="undo redo |  formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists table | removeformat | imageUpload"
					/>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="查看" :visible.sync="dialogVisibles" width="80%" :before-close="handleClose" style="margin-top: -110px;">
			<el-form :model="form.notice" label-width="100px">
				<div class="d-flex" style="width: 100%;">
					<div style="width: 33%;">
						<el-form-item label="信息编号"><el-input v-model="form.notice.id" size="mini" style="width: 90%;" :disabled="true"></el-input></el-form-item>
						<el-form-item label="审核状态">
							<el-button type="warning" size="mini" v-if="form.notice.state == 0">待审核</el-button>
							<el-button type="success" size="mini" v-else-if="form.notice.state == 1">已审核</el-button>
							<el-button type="danger" size="mini" v-else>不通过</el-button>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="发布人"><el-input v-model="form.notice.fbr" size="mini" style="width: 90%;" :disabled="true"></el-input></el-form-item>
						<el-form-item label="标题"><el-input v-model="form.notice.title" size="mini" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="发布时间"><el-input v-model="form.notice.create_time" size="mini" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					</div>
				</div>
				<div style="width: 100%;">
					<el-form-item label="公告内容"><el-input v-model="form.notice.content" size="mini" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					<el-form-item label="访问者">
						<el-table :data="form.notice.fwz" style="width: 50%;height: 270px;overflow-y:scroll;" size="mini" border>
							<el-table-column type="index" label="序号" width="50"></el-table-column>
							<el-table-column prop="name" label="访问者"></el-table-column>
							<el-table-column prop="create_time" label="访问时间"></el-table-column>
						</el-table>
					</el-form-item>
				</div>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibles = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js';
import tinymce from '@/components/common/tinymce.vue';
import { mapState } from 'vuex';
export default {
	mixins: [common],
	inject: ['layout'],
	components: {
		tinymce
	},
	data() {
		return {
			preUrl: 'notice',
			dialogType: 'notice',
			dialogId: 0,
			dialogVisible: false,
			dialogVisibles: false,
			tabIndex: 0,
			tabbars: [{ name: '全部信息', key: 'all' }, { name: '待审核', key: 'dsh' }, { name: '已审核', key: 'ysh' }, { name: '不通过', key: 'btg' }],
			form: {
				// 表单值
				notice: {
					title: '',
					content: '' //用户名
				}
			},
			tableData: [],
			maxHeight: 0
		};
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user
		}),
		// 订单类型
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 274; //300是页面中除了表格外其他组件的高度
		});
	},
	methods: {
		// 鼠标单击的事件
		onClick(e, editor) {},
		upstate(e, f) {
			this.axios
				.post('/admin/notice/' + e + '/update_status', { state: f }, { token: true })
				.then(res => {
					this.$message({
						type: 'success',
						message: '操作成功'
					});
					this.getList();
					this.hideLoading();
				})
				.catch(err => {
					this.hideLoading();
				});
		},
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			console.log(e.list);
			this.tableData = e.list;
			this.cateOptions = e.cates;
		},
		openModel(type, item = false) {
			// 确认类型 （添加管理员、添加角色、添加规则）
			this.dialogType = type;
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'notice':
					if (!item) {
						this.form.notice = {
							title: '',
							content: '',
							fbr: this.user.id
						};
						this.dialogId = 0;
					} else {
						this.form.notice = {
							title: item.title,
							content: item.content
						};
						console.log(this.form.notice);
						this.dialogId = item.id;
					}
					break;
			}
			// 显示弹出层
			this.dialogVisible = true;
		},
		openModels(item = false) {
			console.log(item);
			this.form.notice = {
				title: item.title,
				content: item.content,
				id: item.id,
				create_time: item.create_time,
				fbr: item.fbr.name,
				fwz: item.notices,
				state: item.state
			};
			// 显示弹出层
			this.dialogVisibles = true;
		},
		submit() {
			this.addOrEdit(this.form[this.preUrl], this.dialogId); //调用common.js里的addOrEdit添加/编辑
			this.dialogVisible = false;
		},

		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		}
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.el-dropdown-link {
	cursor: pointer;
	color: #ff8c00;
}
.el-icon-arrow-down {
	font-size: 12px;
}
</style>
